import React, { Fragment } from 'react';

import Component from "./Component";

export default ({ components, hideDecommissioned, allSitesContext }) => (
  <Fragment>
    {
      components.map(
        component => (
          <Component
            key={component.id}
            component={component}
            hideDecommissioned={hideDecommissioned}
            allSitesContext={allSitesContext}
          />
        )
      )
    }
  </Fragment>
);